import { dateToUtc } from '../../../functions';
import { getDashSeparatedDate } from '../../fuctions';

export default function mapResponseLegToTableLeg(legFromResponse: any) {
  let routing = 'N/A';
  if (legFromResponse?.origin?.city && legFromResponse?.destination?.city) {
    routing = `${legFromResponse.origin.city} to ${legFromResponse.destination.city}`;
  }
  return {
    date: getDashSeparatedDate(dateToUtc(new Date(legFromResponse.ship_date))) || '',
    legNumber: legFromResponse.leg_id || '',
    carrierName: legFromResponse.carrier_name || 'N/A',
    service: legFromResponse.service_name || 'N/A',
    routing,
    tracking:legFromResponse.tracking_identifier || 'N/A',
    pickup: legFromResponse.carrier_pickup_identifier || 'N/A',
  };
}
